import { z } from 'zod'

// Valida las variables de entorno al iniciar la app.
// Si alguna variable falta o es inválida, la app falla inmediatamente con un error claro.
//
// Fuentes de cada variable según ambiente:
//   develop    → VITE_API_URL + VITE_ENVIRONMENT de .env.develop   | VITE_ABAKOO_API_KEY de .env.local
//   staging    → VITE_API_URL + VITE_ENVIRONMENT de .env.staging   | VITE_ABAKOO_API_KEY de Cloudflare Pages
//   production → VITE_API_URL + VITE_ENVIRONMENT de .env.production | VITE_ABAKOO_API_KEY de Cloudflare Pages
const envSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_ABAKOO_API_KEY: z.string().startsWith('abk'),
  VITE_ENVIRONMENT: z.enum(['develop', 'staging', 'production']),
})

export const env = envSchema.parse(import.meta.env)
